import store from '@/store/store.js';
import router from '@/router/router';
import axios from '@/axios';
import theApi from '@/mixins/theApi';

export default {
  async login(context, payload) {
    let formData = new FormData();
    formData.append('email', payload.email);
    formData.append('password', payload.password);

    theApi.methods.makeCall(false, 'teacher/login', 'post', formData, null, true).then(
      (responseData) => {
        localStorage.setItem('token', responseData.api_token);
        localStorage.setItem('login_type', 'teacher');
        localStorage.setItem('fname', responseData.fname);
        localStorage.setItem('lname', responseData.lname);
        context.commit('setUser', {
          token: responseData.api_token,
          email: responseData.email,
          fname: responseData.fname,
          lname: responseData.lname,
          notifications: responseData.notifications,
        });
        window.location.href = '/teacher/dashboard';
      },
      () => {},
    );
  },

  async tryLogin(context) {
    const appLoading = document.getElementById('loading-bg-full');
    appLoading.style.display = 'block';

    return new Promise((resolve, reject) => {
      const loginType = localStorage.getItem('login_type');
      const token = localStorage.getItem('token');
      if (loginType != 'teacher' || token.length == 0) {
        localStorage.removeItem('token');
        localStorage.removeItem('login_type');
        localStorage.removeItem('fname');
        localStorage.removeItem('lname');
        router.push('/teacher/login');
      }
      axios.post($vjeConfig.VUE_APP_API_URL + 'teacher/checkToken').then(
        (response) => {
          const responseData = response.data;
          // The data is available now. Finally we can commit something
          if (responseData.status == 'OK') {
            localStorage.setItem('fname', responseData.fname);
            localStorage.setItem('lname', responseData.lname);
            context.commit('setUser', {
              token: responseData.api_token,
              fname: responseData.fname,
              lname: responseData.lname,
              email: responseData.email,
              school: responseData.school,
              access_type: responseData.access_type,
              notifications: responseData.notifications,
            });
            appLoading.style.display = 'none';
            resolve();
          } else {
            appLoading.style.display = 'none';
            localStorage.removeItem('token');
            localStorage.removeItem('login_type');
            localStorage.removeItem('fname');
            localStorage.removeItem('lname');
            reject();
          }
        },
        () => {
          appLoading.style.display = 'none';
          localStorage.removeItem('token');
          localStorage.removeItem('login_type');
          localStorage.removeItem('fname');
          localStorage.removeItem('lname');
          reject();
        },
      );
    });
  },
  async logout(context) {
    const res = await theApi.methods.makeCall(false, 'logout', 'post');
    localStorage.removeItem('token');
    localStorage.removeItem('login_type');
    localStorage.removeItem('fname');
    localStorage.removeItem('lname');
    context.commit('setUser', {
      token: '',
      email: '',
      fname: '',
      lname: '',
      access_type: false,
      notifications: [],
    });
    window.location.href = res.url;
  },

  async approveCertificate(context, payload) {
    const formData = new FormData();
    formData.append('student_vje_id', payload);

    theApi.methods.makeCall(false, 'vje_students/approve_certificate', 'post', formData).then(
      (data) => {
        if (data.status == 'OK') {
          store.commit('authTeacher/setPostwork', data.data.postwork);
        }
      },
      () => {},
    );
  },
  async saveSettings(context, payload) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
      formData.append(key, JSON.stringify(value));
    }
    theApi.methods
      .makeCall(false, 'vje/save_settings', 'post', formData, 'Settings saved successfully.', true)
      .then(
        (data) => {
          if (data.status == 'OK') {
            store.commit('authTeacher/setSettings', payload);
          }
        },
        () => {},
      );
  },
  markLastNotificationsRead(context, numUnread) {
    const formData = new FormData();
    formData.append('num_unread', numUnread);

    theApi.methods.makeCall(false, 'notifications/mark_read', 'post', formData).then(
      () => {
        store.commit('authTeacher/markNotificationsRead', numUnread);
      },
      () => {},
    );
  },
  clearNotifications() {
    theApi.methods.makeCall(false, 'notifications/clear', 'post').then(
      () => {
        store.commit('authTeacher/setNotifications', []);
      },
      () => {},
    );
  },
  markNotificationRead(context, nID) {
    const formData = new FormData();
    formData.append('notification_id', nID);
    theApi.methods.makeCall(false, 'notifications/mark_notification_read', 'post', formData).then(
      () => {
        store.commit('authTeacher/markNotificationRead', nID);
      },
      () => {},
    );
  },
  deleteNotification(context, nID) {
    const formData = new FormData();
    formData.append('notification_id', nID);
    theApi.methods.makeCall(false, 'notifications/delete_notification', 'post', formData).then(
      () => {
        store.commit('authTeacher/deleteNotification', nID);
      },
      () => {},
    );
  },
  deleteNotifications() {
    theApi.methods.makeCall(false, 'notifications/delete_all_notifications', 'post').then(
      () => {
        store.commit('authTeacher/deleteNotifications');
      },
      () => {},
    );
  },
};
